import { useQuery } from '@tanstack/react-query';
import PracticeService from '../../../services/practice-service';

const useGetPosts = (practiceId: number) => {
  return useQuery({
    queryKey: ['posts', practiceId],
    queryFn: () => PracticeService.getPosts(practiceId),
    enabled: !!practiceId, // Only run the query if practiceId is truthy
    // The chat renders turns locally without writing them back to this cache,
    // so a cached result can be missing the whole conversation. Always reload
    // the stored history when a chat is opened.
    refetchOnMount: 'always',
  });
};

export default useGetPosts;
